import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ParkingAndReservation } from 'models/parking-and-reservation';
import api from 'services/api';

import { clearParkingAndReservation } from './actions';

interface ParkingAndReservationsState {
  activeParkingAndReservation?: ParkingAndReservation;
}

const initialState: ParkingAndReservationsState = {
  activeParkingAndReservation: undefined,
};

const setActiveParkingAndReservationState = (
  state: ParkingAndReservationsState,
  { payload }: PayloadAction<{ data: ParkingAndReservation }>,
) => {
  state.activeParkingAndReservation = payload.data;
};

const clearActiveParkingAndReservationState = () => initialState;

const setActiveParkingToState = (
  state: ParkingAndReservationsState,
  { payload }: PayloadAction<{ parking: any }>,
) => {
  state.activeParkingAndReservation = payload.parking;
};

export const parkingAndReservationsSlice = createSlice({
  name: 'parkingAndReservations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(clearParkingAndReservation, () => initialState);
    builder.addMatcher(
      api.endpoints.reserveDevice.matchFulfilled,
      setActiveParkingAndReservationState,
    );
    builder.addMatcher(
      api.endpoints.getActiveParkingAndReservation.matchFulfilled,
      setActiveParkingAndReservationState,
    );
    builder.addMatcher(
      api.endpoints.cancelDeviceReservation.matchFulfilled,
      clearActiveParkingAndReservationState,
    );
    builder.addMatcher(api.endpoints.stopCharging.matchFulfilled, setActiveParkingToState);
  },
});

export default parkingAndReservationsSlice.reducer;
